import { HTMLAttributes } from "react"

type GraphConfig = {
  dataKey: string
  label?: string
  color?: string
  isDashed?: boolean
  [key: string]: unknown
}

export default function VerticalLegend({ graphs }: { graphs: GraphConfig[] }) {
  return (
    <div className="flex justify-start items-center gap-system-xs flex-wrap">
      {graphs.map((graph: GraphConfig) => {
        const color = graph.color || "#FFFFFF"
        const style = {
          background: graph.isDashed ? "transparent" : color,
          borderLeft: graph.isDashed ? `3px dashed ${color}` : "none",
        } as HTMLAttributes<HTMLDivElement>["style"]
        return (
          <div
            key={graph.dataKey}
            className="h-system-xl py-0.5 px-2 text-start flex items-center justify-between gap-system-xs"
          >
            <div className="w-system-xxs h-full rounded" style={style}></div>
            {graph.label || graph.dataKey}
          </div>
        )
      })}
    </div>
  )
}
